import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Divider, List, Typography } from '@mui/material';

// third-party
import { FormattedMessage } from 'react-intl';

// project imports
import NavItem from '../NavItem';
import NavCollapse from '../NavCollapse';

// project hooks
import useAuth from 'hooks/useAuth';

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = ({ group }) => {
    const theme = useTheme();
    const { user } = useAuth();

    return user?.authorizations?.some((auth) => auth?.startsWith(group?.id)) ? (
        <>
            <List
                subheader={
                    group?.title && (
                        <Typography
                            variant="caption"
                            sx={{ ...theme.typography.menuCaption, textTransform: 'none' }}
                            display="block"
                            gutterBottom
                        >
                            {group.title}
                            {group?.caption && (
                                <Typography
                                    variant="caption"
                                    sx={{ ...theme.typography.subMenuCaption, textTransform: 'none' }}
                                    display="block"
                                    gutterBottom
                                >
                                    {group.caption}
                                </Typography>
                            )}
                        </Typography>
                    )
                }
            >
                {group?.children?.map((item) => {
                    switch (item?.type) {
                        case 'collapse':
                            return <NavCollapse key={item?.id} menu={item} level={1} />;
                        case 'item':
                            return <NavItem key={item?.id} item={item} level={1} />;
                        default:
                            return (
                                <Typography key={item?.id} variant="h6" color="error" align="center">
                                    <FormattedMessage id="menuitems-error" />
                                </Typography>
                            );
                    }
                })}
            </List>
            {/* group divider */}
            <Divider sx={{ mt: 0.25, mb: 1.25 }} />
        </>
    ) : (
        <></>
    );
};

NavGroup.propTypes = {
    group: PropTypes.object
};

export default NavGroup;
